import * as yup from "yup";

export const accountSchema = yup.object().shape({
    first_name: yup.string().trim().required("Field is required"),
    last_name: yup.string().trim().required("Field is required"),
    title: yup.string().trim().required("Field is required"),
});
